import { AxiosResponse } from 'axios';
import { TypeDoc } from 'shell/models/type-doc';
import { HttpResponse } from 'shell/models/http-response';
import { TypeDocForm } from '../form';

export const transformTypeDoc = (response: AxiosResponse<HttpResponse<TypeDoc>>): TypeDocForm => {
  const data: TypeDoc = response.data.payload || {};

  const result: TypeDocForm = {
    code: data.key?.codiceDocumento || '',
    description: data.descrizioneTipoDocumento || '',
    typeDoc: data.key?.tipoDocumento || '',
    typeRights: data.tipoDiritti,
    mode: data.modalitaRilascio || '', // TODO estrarre la descrizione
    template: data.codiceTemplate || '',
    holderType: data.tipoIntestatario || '',
    groupDoc: data.gruppoDocumento || '',
    isAire: data.flagIscrittiAire === '1' ? true : false,
    isUse: data.flagDocumentoInUso === '1' ? true : false,
  };

  return result;
};
